import store from "@/store";
import { getFinanceOverview, unwrapFinance } from "@/service/hyc_finance_common";
import { canHycFinance } from "@/utils/hyc-finance-permission";

export function applyHycFinanceCounts(data) {
    const billing = (data.billing || []).reduce((sum, row) => sum + Number(row.count || 0), 0);
    const customer = Number(data.reward?.customer_pending?.count || 0);
    const channel = Number(data.reward?.channel_pending?.count || 0);
    const exceptions = (data.exceptions || []).reduce((sum, row) => sum + Number(row.count || 0), 0);
    const counts = { "finance-hyc": billing + customer + channel, "finance-hyc-refunds": billing,
        "finance-hyc-reward-customers": customer, "finance-hyc-reward-actors": channel, "finance-hyc-exceptions": exceptions };
    Object.entries(counts).forEach(([key, value]) => store.commit("app/SET_COUNTS", { key, value }));
}

export async function refreshHycFinanceCounts() {
    if (!canHycFinance("manage_bill")) return;
    applyHycFinanceCounts(unwrapFinance(await getFinanceOverview()));
}
